module.exports = __webpack_public_path__ + "img/rock-big-13.c9111a8a.png";